export default {
  metadata: {
    version: '1.0.0',
    id: 'table-1.0.0',
    name: 'JDSTable',
    description:
      "Simple tables display information in a tabular data format with rows and columns. The organize information in a way that's easy to scan so that users can look for patterns and develop insights from data.",
    usage:
      'Simple tables are used on wide viewports only or whenever their layout can easily fit in the screen - not too many columns.'
  },
  hierarchy: {
    container: ['jds_table_body', 'footer-jds-text']
  },
  base: {
    container: {
      'flex-direction': '{t_0}',
      'border-radius': '{t_2}',
      'border-width': '{t_3}',
      'border-color': '{t_4}',
      overflow: 'hidden',
      'align-items': '{alignItems.start}'
    },
    'footer-jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-left': '{base}',
      'padding-right': '{base}',
      'padding-top': '{base}',
      'padding-bottom': '{base}',
      hidden: true
    }
  },
  variant: {
    density: {
      condensed: {
        jds_table_body: {
          density: 'condensed'
        },
        'footer-jds-text': {
          'padding-left': '{xs}',
          'padding-right': '{xs}',
          'padding-top': '{xs}',
          'padding-bottom': '{xs}'
        }
      }
    },
    columnDivider: {
      true: {
        jds_table_body: {
          columnDivider: true
        }
      }
    },
    fullWidth: {
      true: {
        container: {
          width: '{t_5}'
        },
        jds_table_body: {
          fullWidth: true
        }
      }
    },
    _hasFooter: {
      true: {
        'footer-jds-text': {
          hidden: false
        }
      }
    }
  },
  api: {
    config: {
      density: {
        type: 'JDSTableCell.density',
        values: ['relaxed', 'condensed']
      },
      background: {
        values: [false, true]
      },
      columnDivider: {
        values: [false, true],
        doc_description: 'Show/hide border between columns.'
      },
      fullWidth: {
        values: [false, true]
      },
      _hasFooter: {
        values: [false, true]
      }
    },
    data: {
      jds_table_body: {
        rows: {
          name: 'rows',
          type: 'list',
          object: {
            cells: 'list'
          },
          doc_description:
            'Pass rows as an array of objects {[HEADER_NAME_1]?: , [HEADER_NAME_2]?:...}, where each row is an object where:\n- the properties are equal to header names\n- values are displayed in columns\n- properties for non-existent header.name are ignored, warning is displayed\n- missing header property results in empty column'
        },
        zebra: {
          type: 'boolean',
          name: 'zebra'
        },
        background: {
          type: 'boolean',
          name: 'background'
        }
      },
      'footer-jds-text': {
        value: {
          type: 'string',
          name: 'footer',
          doc_description: 'Optional text at the bottom.'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'table'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'table'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
